import api from '@/api/Api'
import ApiModel from '@/model/ApiModel'
import store from '@/store'
import Vue from "vue"

let {
    Const
} = ApiModel;
import logger from '@/assets/log'
const log = logger("store:uploader");

const state = {
    showUploader: false,
    UploadServer: {
        loadingStatus: "", //loading,done,error
        url: "",
        id: null,
        path: "",
        uploadUrl: "",
        tokenUrl: "",
        uploadServerId: null,
        softwareId: null,
        uploadServerUrl: ""
    },
    uploadPath: "",
    uploadResult: {
        path: "",
        scaleFile: "",
        name: ""
    },
    uploading: [],
    newMaterialStatus: [

    ],
    fileMaxSizes: {
        fileMaxSize: 0,
        imageMaxSize: 0,
        audioMaxSize: 0,
    }
}

// getters
const getters = {
    videoMaxSize(state) {
        return (configSize) =>
            Math.min(
                state.fileMaxSizes.fileMaxSize || Infinity,
                configSize || state.fileMaxSizes.fileMaxSize || 2 * 1024 * 1024 * 1024)
    },
    imageMaxSize(state) {
        return (configSize) =>
            Math.min(
                state.fileMaxSizes.imageMaxSize || Infinity,
                configSize || state.fileMaxSizes.imageMaxSize || 10 * 1024 * 1024)
    },
    audioMaxSize(state) {
        return (configSize) =>
            Math.min(
                state.fileMaxSizes.audioMaxSize || Infinity,
                configSize || state.fileMaxSizes.audioMaxSize || 100 * 1024 * 1024)
    },
}

// actions
const actions = {
    async onUploaded({
        commit,
        state
    }, {
        res,
        file,
        image_to_video,
        filelist,
        uploadServer,
        categoryId,
        userId,
        material,
        vrFlag
    }) {
        function fileNameToType(name) {
            let ext = name.split(".").pop().toLowerCase();
            let map = {
                video: ["mp4", "flv", "rm", "rmvb", "wmv", "avi", "3gp", "mkv", "mov", "asf", "mpg"],
                audio: ["mp3", "aac", "m4a", "amr", "wav", "wma", "oga", "weba", "alac", "flac", "asf", "mid", "midi", "vqf", "au", "aifc", "mp2"],
                image: ["jpg", "jpeg", "png", "gif", "tif", "svg", "bmp", "webp"]
            };
            if (!ext) return;

            ext = ext.toLowerCase();

            if (map.video.indexOf(ext) >= 0)
                return Const.Material.Type.Video;

            if (map.audio.indexOf(ext) >= 0)
                return Const.Material.Type.Audio;

            if (map.image.indexOf(ext) >= 0){
                if(image_to_video && ext != 'gif'){
                    return Const.Material.Type.Video;
                }else {
                    return Const.Material.Type.Image;
                }
            }
        }
        try {

            log("(:/home/upload) %s: %s %o %o", "上传完成，开始创建素材", file.name, file, res)

            let type = fileNameToType(file.name);

            commit("setUploadPath", res.msg.scaleFile || res.msg.path);
            commit("setUploadResult", res.msg);

            //上传素材时自动提交
            if(material){
                let ret = await api.call("material/save", {
                    name: file.name,
                    // softwareId: uploadServer.softwareId,
                    uploadServerId: uploadServer.softwareId ,
                    uploadServerUrl: uploadServer.uploadServerUrl,
                    uploadUrl: uploadServer.uploadUrl,
                    id: null,
                    type: type,
                    uploadPath: res.msg.path,
                    categoryId: parseInt(categoryId),
                    userId: userId ? (userId | 0) : null,
                    picImagePath: getScaledPosterImage(type, res.msg, uploadServer),
                    userName: store.state.user.name,
                    vrFlag: vrFlag || Const.Material.VRFlag.Common
                });

                commit("newMaterialStatus", {
                    // id: ret.data.id,
                    name: file.name,
                    status: 0,
                    error: null
                });

                log("(:/home/upload) %s: %s", "创建素材完成", file.name)
            }

        } catch (e) {

            commit("newMaterialStatus", {
                id: null,
                name: file.name,
                status: 1,
                error: e
            });

            // log.warn("(:/home/upload) %s %o", "创建素材失败", e)
        }
    },
    async onUploadError({
        commit,
        state
    }, {
        res,
        file,
        filelist,
        error
    }) {
        commit("newMaterialStatus", {
            id: null,
            name: file.name,
            status: 1,
            error: error
        });
    },
    async getUploadServer({
        commit,
    }) {

        commit("setUploaderLoadingStatus", "loading");

        try {
        
            let ret = await api.call("upload/getUploadServer", null, {
                type: 5,
                resize: 1
            });
        
            commit("setUploaderServer", ret);
        
        } catch (e) {
        
            commit("setUploaderLoadingStatus", "error");
        
            log.warn("(:/home/upload) %s %o", "获取上传服务地址失败", e)
        
        }
    },
    async getFileMaxSizes({
        commit,
        state
    }, uploadServerUrl){

        if(state.fileMaxSize) {
            return;
        }

        try {
            let ret = await api.callSimple(uploadServerUrl + "/fileMaxSizes", {}, true);
            
            commit("setFileMaxSizes", ret);
            
        } catch (e) {
                
            // FIXME TEST CODE
            // if(Vue.config.devtools) {
            //     setTimeout(function(){
            //         commit("setFileMaxSizes", {
            //             fileMaxSize: 1
            //         });
            //     }, 500);
            // }
        
            log.warn("(:/home/upload) %s %o", "获取上传服务文件大小限制失败", e)
        
        }
    }
}

// mutations
const mutations = {
    showUploader(state, show) {
        state.showUploader = show;
    },
    setUploaderLoadingStatus(state, status) {
        state.UploadServer.loadingStatus = status;
    },
    setUploaderServer(state, {
        uploadServerUrl,
        uploadServerId,
        uploadUrl,
        tokenUrl,
        softwareId,
    }) {
        state.UploadServer.uploadServerUrl = state.UploadServer.url = uploadServerUrl;
        state.UploadServer.uploadServerId = state.UploadServer.id = uploadServerId;
        state.UploadServer.uploadUrl = uploadUrl;
        state.UploadServer.tokenUrl = tokenUrl;
        state.UploadServer.softwareId = softwareId;
        state.UploadServer.loadingStatus = "done";
    },
    newMaterialStatus(state, material) {
        state.newMaterialStatus.push(material);
    },
    setUploadPath(state, val) {
        state.uploadPath= val;
    },
    setUploadResult(state, result) {
        state.uploadResult = result;
    },
    setUploading(state, val) {
        state.uploading = val;
    },
    setFileMaxSizes(state, { fileMaxSize, imageMaxSize, audioMaxSize }) {
        state.fileMaxSizes = {
            fileMaxSize: (fileMaxSize | 0) * 1024 * 1024,
            imageMaxSize: (imageMaxSize | 0) * 1024 * 1024,
            audioMaxSize: (audioMaxSize | 0) * 1024 * 1024
        };
    }
}

// 获取缩放后的封面图地址
function getScaledPosterImage(type, msg, uploadServer) {
    if (type === Const.Material.Type.Image) {
        if (msg.scaleFile == msg.path || !msg.scaleFile) {
            let scaledUrl =  msg.path.replace(/([.][^.]*?$)/, '.160x$1');
            createScaleImage(scaledUrl, uploadServer);
            return scaledUrl;
        }
        return msg.scaleFile;
    }
    return null;
}

// 如果使用阿里云，阿里云不会访问tomcat，需要访问一次生成缩放图片
function createScaleImage(scaledUrl, uploadServer) {
    let loader = new Image();
    loader.src = uploadServer + scaledUrl; 
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}